import React from 'react'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import {
  Section,
  SectionItem,
  SectionItemHeading,
  SectionItemText,
} from './sharedUI'
import { checkEmpty, getNewsletterConsent } from './utils'
import useTranslation from '../../../utils/translation'
import features from '../../components/features'
import settings from '../../components/settings'
import useBrandConfig from '../../hooks/useBrandConfig'
import { CheckCircle } from '../../components/icons/checkCircle'
import { XIcon } from '../../components/icons/x'

const AdditionalInfo = ({
  createdAt,
  newsletterConsent,
  client,
  comment,
  category,
  purpose,
  clientIp,
  recaptchaScore,
  customerVerified,
  trustScore,
  utmSource,
  utmMedium,
}) => {
  const brandConfig = useBrandConfig(settings.brand).data
  const t = useTranslation('appointment-details')

  const timeZone = brandConfig ? brandConfig.ianaTimeZoneId : 'UTC'
  const utcTime = moment.utc(createdAt)
  const localTime = utcTime.tz(timeZone)

  return (
    <>
      <Section noBottomBorder>
        {createdAt !== null && (
          <SectionItem>
            <SectionItemHeading>{t('created')}</SectionItemHeading>
            <SectionItemText>
              {localTime
                ? localTime.format('YYYY-MM-DD HH:mm')
                : moment(createdAt).format('YYYY-MM-DD HH:mm')}
            </SectionItemText>
          </SectionItem>
        )}
        {newsletterConsent !== null && (
          <SectionItem>
            <SectionItemHeading>{t('newsletter-consent')}</SectionItemHeading>
            <SectionItemText>
              {getNewsletterConsent(newsletterConsent, t)}
            </SectionItemText>
          </SectionItem>
        )}
        {comment && comment.length !== 0 && (
          <SectionItem mobileSize="100%">
            <SectionItemHeading>{t('comments')}</SectionItemHeading>
            <SectionItemText>{checkEmpty(comment)}</SectionItemText>
          </SectionItem>
        )}
        {settings.brand === 'magnet' && clientIp && (
          <SectionItem mobileSize="100%">
            <SectionItemHeading>{t('clientIp')}</SectionItemHeading>
            <SectionItemText>{checkEmpty(clientIp)}</SectionItemText>
          </SectionItem>
        )}
        {features.useRecaptcha && (
          <SectionItem mobileSize="100%">
            <SectionItemHeading>{t('recaptchaScore')}</SectionItemHeading>
            <SectionItemText>{checkEmpty(recaptchaScore)}</SectionItemText>
          </SectionItem>
        )}
        {features.verification && (
          <SectionItem mobileSize="100%">
            <SectionItemHeading>Customer verified</SectionItemHeading>
            <SectionItemText>
              {customerVerified ? (
                <CheckCircle width={20} height={20} />
              ) : (
                <XIcon stroke="#f00" width={24} height={24} />
              )}
            </SectionItemText>
          </SectionItem>
        )}
        {features.showTrustScore && (
          <SectionItem mobileSize="100%">
            <SectionItemHeading>{t('trustScore')}</SectionItemHeading>
            <SectionItemText>{checkEmpty(trustScore)}</SectionItemText>
          </SectionItem>
        )}
        {utmSource && utmSource.length !== 0 && (
          <SectionItem mobileSize="100%">
            <SectionItemHeading>{t('utmsource')}</SectionItemHeading>
            <SectionItemText>{checkEmpty(utmSource)}</SectionItemText>
          </SectionItem>
        )}
        {utmMedium && utmMedium.length !== 0 && (
          <SectionItem mobileSize="100%">
            <SectionItemHeading>Utm medium</SectionItemHeading>
            <SectionItemText>{checkEmpty(utmMedium)}</SectionItemText>
          </SectionItem>
        )}
      </Section>
      {features.kratos && client === 'kratos' && (
        <Section>
          <SectionItem>
            <SectionItemHeading>{t('purpose')}</SectionItemHeading>
            <SectionItemText>{t(`purpose.${purpose}`)}</SectionItemText>
          </SectionItem>
          {category !== null && (
            <SectionItem>
              <SectionItemHeading>{t('category')}</SectionItemHeading>
              <SectionItemText>{t(`category.${category}`)}</SectionItemText>
            </SectionItem>
          )}
        </Section>
      )}
    </>
  )
}

AdditionalInfo.propTypes = {
  createdAt: PropTypes.string,
  newsletterConsent: PropTypes.bool,
  comment: PropTypes.string,
  customerVerified: PropTypes.bool,
}

AdditionalInfo.defaultProps = {
  createdAt: null,
  newsletterConsent: null,
  comment: '',
  customerVerified: false,
}

export default AdditionalInfo
